const body = $('body');
let offCanvasOpen = false;

body.on('click', '#burger-nav', function (e) {
    e.stopPropagation();
    if (!offCanvasOpen) {
        $('.off-canvas').show();
        offCanvasOpen = true;
        //Disable scrolling
        $("body").css("overflow", "hidden");

    } else {
        $('.off-canvas').hide();
        offCanvasOpen = false;
        //Re-enable scrolling
        $("body").css("overflow", "auto");
    }

});

body.on('click', '.off-canvas', function (e) {
    e.stopPropagation();
});

//Menu close button
body.on('click', '.off-canvas .close', function (e) {
    $('.off-canvas').hide();

    //Re-enable scrolling
    $("body").css("overflow", "auto");

    offCanvasOpen = false;
});

//Dropdown
body.on('click', '.navbar .dropdown .trigger', function (e) {
    $(this).siblings(".dropdown-content").toggleClass("open");
    $(".navbar-dropdown-overlay").toggleClass("open");
    e.stopPropagation();
});

body.on('click', '.navbar .off-canvas .dropdown >a', function (e) {
    $(this).closest(".dropdown").toggleClass("open");
});

$(document).on('click', function (e) {
    // Off-canvas menu
    if (offCanvasOpen) {
        $('.off-canvas').animate({right: "-275px"}, 100, "swing");
        offCanvasOpen = false;
    }

    // Dropdowns
    $(".navbar .dropdown-content.open").removeClass("open");
    $(".navbar-dropdown-overlay").removeClass("open");
});


$(document).on('click', function (e) {
    // Off-canvas menu
    if (offCanvasOpen) {
        $('.off-canvas').animate({right: "-275px"}, 100, "swing");
        offCanvasOpen = false;
    }
});

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function () {
    // Open mobile menu
    const burgerNav = document.getElementById('burger-nav');
    const offCanvas = document.querySelector('.off-canvas');
    const overlay = document.querySelector('.navbar-dropdown-overlay');
    const closeBtn = document.querySelector('.off-canvas .close');

    if (burgerNav) {
        burgerNav.addEventListener('click', function () {
            offCanvas.classList.add('open');
            overlay.classList.add('open');
            document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
        });
    }

    // Close mobile menu
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            offCanvas.classList.remove('open');
            overlay.classList.remove('open');
            document.body.style.overflow = ''; // Restore scrolling
        });
    }

    // Close menu when clicking overlay
    if (overlay) {
        overlay.addEventListener('click', function () {
            offCanvas.classList.remove('open');
            overlay.classList.remove('open');
            document.body.style.overflow = ''; // Restore scrolling
        });
    }

    // Handle mobile dropdowns
    const mobileDropdownHeaders = document.querySelectorAll('.mobile-dropdown-header');

    mobileDropdownHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const content = header.nextElementSibling;
            const isOpen = header.classList.contains('open');

            // Close all other dropdowns
            document.querySelectorAll('.mobile-dropdown-header.open').forEach(openHeader => {
                if (openHeader !== header) {
                    openHeader.classList.remove('open');
                    openHeader.nextElementSibling.classList.remove('open');
                }
            });

            // Toggle current dropdown
            if (isOpen) {
                header.classList.remove('open');
                content.classList.remove('open');
            } else {
                header.classList.add('open');
                content.classList.add('open');
            }
        });
    });

    // Close mobile menu on page transition
    document.querySelectorAll('.mobile-nav-items a, .mobile-dropdown-content a').forEach(link => {
        link.addEventListener('click', () => {
            offCanvas.classList.remove('open');
            overlay.classList.remove('open');
            document.body.style.overflow = '';
        });
    });

    // Handle desktop dropdowns (existing functionality preserved)
    const dropdownTriggers = document.querySelectorAll('.dropdown .trigger');

    dropdownTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const dropdown = trigger.nextElementSibling;
            const isOpen = dropdown.classList.contains('open');

            // Close all other dropdowns
            document.querySelectorAll('.dropdown-content.open').forEach(openDropdown => {
                if (openDropdown !== dropdown) {
                    openDropdown.classList.remove('open');
                    overlay.classList.remove('open');
                }
            });

            // Toggle current dropdown
            if (isOpen) {
                dropdown.classList.remove('open');
                overlay.classList.remove('open');
            } else {
                dropdown.classList.add('open');
                overlay.classList.add('open');
            }
        });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', () => {
        document.querySelectorAll('.dropdown-content.open').forEach(dropdown => {
            dropdown.classList.remove('open');
            overlay.classList.remove('open');
        });
    });
});